import { Controller } from 'stimulus';
import debounce from 'lodash.debounce';
// @ts-ignore
import autosize from 'autosize';
import { findParent, findChild } from '../helpers';
import { MouseEvent } from 'react';

export default class LessonVocabFeedbackController extends Controller {
  static targets = ['vocabTerm', 'sentencePinyinInput'];

  vocabTermTargets: HTMLElement[];
  sentencePinyinInputTargets: HTMLInputElement[];

  debouncedUpateFuncs = new Map();

  deleteVocabTerm(evt: MouseEvent<HTMLElement>) {
    this.findVocabTerm(evt.currentTarget).remove();
  }

  updatePinyin(evt: MouseEvent<HTMLInputElement>) {
    this.debouncedloadAndUpdatePinyin(evt.currentTarget);
  }

  debouncedloadAndUpdatePinyin(sentenceInput: HTMLInputElement) {
    let debouncedUpdate = this.debouncedUpateFuncs.get(sentenceInput);
    if (!debouncedUpdate) {
      debouncedUpdate = debounce(() => this.loadAndUpdatePinyin(sentenceInput), 500, {
        trailing: true,
      });
      this.debouncedUpateFuncs.set(sentenceInput, debouncedUpdate);
    }
    debouncedUpdate();
  }

  async loadAndUpdatePinyin(sentenceInput: HTMLInputElement) {
    const $vocabTerm = this.findVocabTerm(sentenceInput);
    const $sentenceInput = $(sentenceInput);
    const $sentencePinyinInput = this.findSentencePinyinInput($vocabTerm[0]);
    const sentenceText = $sentenceInput.val() as string;
    if (sentenceText.trim()) {
      $sentencePinyinInput.show();
      const pinyinParts = await Promise.all(sentenceText.trim().split(/\n/).map((sentencePart) => {
        if (!sentencePart.trim()) return Promise.resolve(sentencePart);
        return $.getJSON('/api/pinyin', { text: sentencePart });
      }));
      // make sure the user hasn't changed the input since this request came back
      if (sentenceText === $sentenceInput.val()) {
        $sentencePinyinInput.val(pinyinParts.join('\n'));
        autosize.update($sentencePinyinInput);
      }
    } else {
      $sentencePinyinInput.val('').hide();
    }
  }

  findVocabTerm(containedElm: HTMLElement) {
    return findParent(containedElm, this.vocabTermTargets);
  }

  findSentencePinyinInput(vocabTerm: HTMLElement) {
    return findChild(vocabTerm, this.sentencePinyinInputTargets);
  }
}
